import moment from 'moment'

import clientSDK from '../../../App/ClientSDK'
import {
  IAbsenceFormBase,
  IAPIAbsenceFormBase,
  IAPIAbsenceFormBaseResponse,
} from '../../layout/AbsenceFormBase/IAbsenceFormBase'
import {
  IAbsenceRequest,
  IAPIAbsenceRequest,
  IAPIAbsenceRequestResponse,
} from '../IAbsenceRequestNew'

interface ICreateAbsenceRequest {
  starts_at: string
  ends_at: string
  absence_type_uuid: string
  reason: string
}

const baseUrl = 'hr/absence-requests'

const absenceRequestApiTransformer = (
  data: IAPIAbsenceRequest,
): IAbsenceRequest => ({
  id: data.id,
  uuid: data.uuid,
  startsAt: moment(data.starts_at),
  endsAt: moment(data.ends_at),
  absenceType: {
    uuid: data.absence_type.uuid,
    key: data.absence_type.key,
    color: data.absence_type.color,
    shouldBeCaughtUp: data.absence_type.should_be_caught_up,
  },
  reason: data.reason,
  person: {
    id: data.person.id,
    uuid: data.person.uuid,
    avatar: data.person.avatar,
    firstName: data.person.first_name,
    lastName: data.person.last_name,
    fullName: data.person.full_name,
  },
  status: data.status,
  reviewReason: data.review_reason,
})

const getList = async () => {
  const response = await clientSDK
    .instance()
    .get<IAPIAbsenceRequestResponse>(baseUrl)
  const data = response.data
  return data.list.map(absence => absenceRequestApiTransformer(absence))
}

const getAbsenceRequest = async (absenceRequestUuid: string) => {
  const response = await clientSDK
    .instance()
    .get<IAPIAbsenceRequest>(`${baseUrl}/${absenceRequestUuid}`)
  const data = response.data
  return absenceRequestApiTransformer(data)
}

const createAbsenceRequest = (absenceRequest: ICreateAbsenceRequest) => {
  return clientSDK
    .instance()
    .post<ICreateAbsenceRequest>(baseUrl, absenceRequest)
}

const updateAbsenceRequest = async (generalAbsenceObject: {
  absenceRequest: ICreateAbsenceRequest
  absenceRequestUuid: string
}) => {
  const { absenceRequest, absenceRequestUuid } = generalAbsenceObject
  const response = await clientSDK
    .instance()
    .patch<ICreateAbsenceRequest>(
      `${baseUrl}/${absenceRequestUuid}`,
      absenceRequest,
    )
  return response.data
}

const useAbsenceRequestService = {
  getList,
  getAbsenceRequest,
  createAbsenceRequest,
  updateAbsenceRequest,
}

export default useAbsenceRequestService
